import * as React from 'react'

const CrunchSquareLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='88' height='88' viewBox='0 0 88 88' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width='88' height='88' rx='18' fill='#FE195B' />
    <path d='M43.5565 71C26.7099 71 14 59.2002 14 43.5004C14 27.8006 26.7099 16 43.5565 16C54.4512 16 64.0344 21.043 69.1788 29.3219L69.5822 29.8927L59.3938 36.3638L58.9905 35.6028C57.6071 32.8443 55.4226 30.5127 52.6907 28.8786C49.9587 27.2445 46.7914 26.375 43.5565 26.3711C33.8728 26.3711 26.2061 33.8882 26.2061 43.4989C26.2061 53.1096 33.7739 60.6283 43.5565 60.6283C52.2317 60.6283 59.2966 54.8235 60.604 46.452L60.7053 45.7858H73.0118L72.9105 46.6423C71.297 61.0088 59.1922 71 43.5565 71Z' fill='white' />
  </svg>
)

export default React.memo(CrunchSquareLogo)
